/**
 * Created by gusenlin on 2018/5/30.
 */
import store from 'src/vuex/index';
import { fetch } from '@/utils/fetch';
import { getClientCode } from '@/utils/environment';
import { checkAccountErr } from '@/api/getData';
import { revertGetParams } from 'utils/indexV2';
import { applicationManageGuide } from 'views/refactor-main/application-manage/application-manage.guide.service.js';
import { collectApplicationList } from 'service/main';

function getMobileWhitelistData(data) {
  let info = store.state.hlyStopAnnouncement;
  let whitelistAppCode = (info && info.whitelistAppCode) || [];
  if (whitelistAppCode.length > 0) {
    data.whitelistAppCodeList = whitelistAppCode;
  }
  return data;
}

export const getMyProfile = () => {
  let data = getMobileWhitelistData({
    clientCode: getClientCode(),
  });
  return fetch({
    //url: jonUrl('/mobile/api/myProfile/v2'),
    url: '/mobile/api/myProfile/v2',
    method: 'POST',
    data,
  });
};

//
export const getCompanyConfigurations = () => {
  return fetch({
    url: '/api/my/companies',
    method: 'GET',
  });
};

export const getCompanyCarousels = (companyOID) => {
  return fetch({
    url: '/api/carousels/company/' + companyOID,
    method: 'GET',
  });
};

// 记录公告已弹窗
export const recordCarouselsDisplayed = (data) => {
  return fetch({
    url: '/api/carousels/record',
    method: 'POST',
    data,
  });
};

// 记录公告弹窗阅读情况
export const recordCarousels = ({ carouselOid }) => {
  return fetch({
    url: `/api/carousels/clicked?carouselOid=${carouselOid}`,
    method: 'POST',
  });
};

export const getWorkWidget = () => {
  return fetch({
    url: '/api/work/widget?platform=MOBILE',
    method: 'GET',
  });
};

export const getCarouselByID = (carousel) => {
  return fetch({
    url: '/api/carousels/' + carousel,
    method: 'GET',
  });
};

/**
 * 获取常用应用
 * @returns {*}
 */
export const getUsualApplication = () => {
  let data = getMobileWhitelistData({
    platform: 'ANDROID',
    appVersion: '2.19.1',
    clientCode: getClientCode(),
  });
  return fetch({
    //url: jonUrl('/mobile/api/app/management/index'),
    url: '/mobile/api/app/management/index',
    method: 'POST',
    data,
  });
};

//获取快捷应用
export const getFastCreate = () => {
  let data = getMobileWhitelistData({
    platform: 'ANDROID',
    appVersion: '2.18.8',
  });
  return fetch({
    //url: jonUrl('/mobile/api/app/fast'),
    url: '/mobile/api/app/fast',
    method: 'POST',
    data,
  });
};

/**
 * 修改常用应用
 * @param data
 * @returns {*}
 */
export const putUsualApplication = (data) => {
  return fetch({
    url: '/mobile/api/app/management/person',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const getAccountV2 = () =>
  fetch({
    url: '/auth/api/account',
    method: 'GET',
  }).catch((err) => {
    checkAccountErr(err);
    throw err;
  });

export const getProxyAccount = () =>
  fetch({
    url: '/v1/auth/api/account',
    method: 'GET',
  }).catch((err) => {
    checkAccountErr(err);
    throw err;
  });

export const getTenantProfile = (tenantId) =>
  fetch({
    url: `/api/tenant/getById?tenantId=${tenantId}`,
    method: 'GET',
  });

/**
 * 获取全部应用
 * @returns {*}
 */
export const getAllApplication = () => {
  let data = getMobileWhitelistData({
    platform: 'ANDROID',
    appVersion: '1.0.6',
    clientCode: getClientCode(),
  });
  return fetch({
    url: '/mobile/api/work',
    method: 'POST',
    data,
  });
};

/**
 * 获取油卡话费链接
 * @returns {*}
 */
export const getYGETUrl = () => {
  return fetch({
    url: '/vendor-info-service/api/sso/common?newVendorsName=yget',
    method: 'GET',
  });
};

/**
 * 获取里程补贴模式
 * @returns {*}
 */
export const getPcfpMode = () => {
  return fetch({
    url: '/api/pcfp/mode',
    method: 'GET',
  });
};

/**
 * 获取待审批单据数量
 * @returns {*}
 */
export const getApprovalsQuantity = (params) => {
  let url = '/api/approvals/filters/count?roleType=TENANT';
  let paramsUrl = revertGetParams(params);
  return fetch({
    url: url + paramsUrl,
    method: 'GET',
  });
};

/**
 * 获取单据创建历史
 * @returns {*}
 */
export const getCreateHistory = () => {
  return fetch({
    url: '/api/form/histories',
    method: 'GET',
  });
};

/**
 * 获取单据创建历史
 * @returns {*}
 */
export const getCreateHistoryV2 = () => {
  return fetch({
    url: '/api/form/histories/v2?number=2&entityTypes=1001,1002,3001',
    method: 'GET',
  });
};

/**
 * 获取是否是新租户
 * 返回结果false 为新租户
 * @returns {*}
 */
export const getTenantCheck = () => {
  return fetch({
    url: '/api/tenant/check/exsit/company/his',
    method: 'GET',
    nativeResponseSerializer: 'boolean',
  });
};

/**
 * 获取单据动态
 * @param page
 * @param size
 * @returns {*}
 */
export const getDocumentStatus = (page = 0, size = 5) => {
  return fetch({
    url: '/api/approvals/latest',
    method: 'GET',
    params: {
      page,
      size,
    },
  });
};

/**
 * 获取商务出行行程列表
 * @returns {*}
 */
export const getBusinessTravelList = () => {
  return fetch({
    url: '/api/travel/application/last',
    method: 'GET',
  });
};

/**
 * 获取单据动态
 * @param appCode
 * @param status
 * @returns {*}
 */
export const changeProtocolStatus = (appCode, status) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/mobile/api/user/protocol',
      method: 'POST',
      data: {
        appCode,
        status,
      },
    })
      .then((res) => {
        applicationManageGuide.getAllApplicationByApi(true).then();
        getUsualApplication().then((res) => {
          if (res && res.data) {
            let applicationListMap = collectApplicationList('QUICK_MENU', res.data);
            store.commit('setAllApplicationListMap', applicationListMap);
            store.commit('setQuickMenu', res.data);
          }
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getLanguageList = (language) => {
  return fetch({
    url: `/api/lov/language/${language}`,
    method: 'POST',
  });
};

export const productStatisticsInterface = (platform, appVersion) => {
  return fetch({
    url: '/mobile/api/user/version/app/record',
    method: 'POST',
    data: {
      platform,
      appVersion,
    },
  });
};

export const putUserGuied = (guided) => {
  return fetch({
    url: '/api/user/guided',
    method: 'PUT',
    params: {
      guided,
      client: 'app',
    },
  });
};

export const getUserGroupsByUserOid = (params) => {
  return fetch({
    url: '/api/implement/search/userGroups/by/userOid',
    method: 'GET',
    params,
  });
};

/*function jonUrl(url) {
  url = url + '?';
  let info = store.state.hlyStopAnnouncement;
  if (info && info.whitelistAppCode && info.whitelistAppCode.length) {
    info.whitelistAppCode.forEach((item) => (url = url + '&whitelistAppCode=' + item));
  }
  return url;
}*/

export const getPermission = (appCode) => {
  return fetch({
    url: '/mobile/api/work/gui/widget/sub/menu/permission',
    method: 'GET',
    params: {
      platform: 'ANDROID',
      appVersion: '1.0.6',
      clientCode: getClientCode(),
      appCodes: appCode,
    },
  });
};

// 查询引导记录
export const getUserGuideRecord = () => {
  return fetch({
    url: '/api/user/guide/record',
    method: 'GET',
  });
};

// 更新引导记录
export const updateUserGuideRecord = (params) => {
  return fetch({
    url: '/api/user/guide/record',
    method: 'POST',
    data: params,
  });
};

//获取自定义协议
export const getSelfDefinedProtocol = () => {
  return fetch({
    url: '/auth/api/tenant/protocol/agree',
    method: 'GET',
  });
};
export const agreeSelfDefinedProtocol = (params) => {
  return fetch({
    url: '/api/tenant/protocol/agree?roleType=TENANT&accept=true',
    method: 'POST',
    data: params,
  });
};

// 获取云环境/租户自定义配置
export const getAllocation = (params) => {
  return fetch({
    url: '/operationservice/public/get/allocation',
    method: 'GET',
    params,
  });
};

// 获取标签配置信息
export const getLabelConfig = () => {
  return fetch({
    url: '/api/label/layout/personal',
    method: 'GET',
  });
};
